import { Directive } from "vue";
import { sanitize } from "@/utils";

/**
 * v-safe-html — drop-in replacement for v-html that runs the bound value
 * through DOMPurify. Registered globally in app.ts, so it works in every
 * template style (Options API included, where module imports are not
 * reachable from template expressions). Re-sanitizes only when the bound
 * value changes, so unrelated re-renders don't re-parse unchanged HTML.
 */
export const safeHtml: Directive<HTMLElement, string | null | undefined> = {
    mounted(el, binding) {
        el.innerHTML = sanitize(binding.value);
    },
    updated(el, binding) {
        if (binding.value !== binding.oldValue) {
            el.innerHTML = sanitize(binding.value);
        }
    },
};
